var docParams = {
  fileName: 'params.json',
  params: {}
};

docParams.init = function() {
    var urlToDocParams = loadContent.pathToDoc + docParams.fileName;
    var ajaxTest = $.ajax({
  		url: urlToDocParams
  		, global: false
  		, dataType: "json"
  		, success: docParams.successLoadParams
  		, error: docParams.failLoadParams
  	});
}

docParams.successLoadParams = function(data, textStatus, jqXHR) {
    docParams.params = data;
}

docParams.failLoadParams = function() {
    console.log("error load doc params");
}
